import $ from 'jquery';

export default {
    isMobileDevice: () => {
        return $(window).width() < 768
    }
}